/**
 * `/lehrer/medien`: the teacher's media library.
 */
import { t } from '@shared/i18n/de';
import { createLifetime } from '@shared/lifetime';
import { createMediaLibrary, type MediaLibraryHandle } from '@shared/ui/media-library';
import { workLayout } from '../layout';
import { currentTeacher, renderLogin } from './common';

export function renderMediaPage(mount: HTMLElement): () => void {
  const life = createLifetime();
  let library: MediaLibraryHandle | null = null;

  void (async () => {
    const teacher = await currentTeacher();
    if (life.isDisposed()) return;
    if (teacher === null) {
      renderLogin(mount, () => {
        renderMediaPage(mount);
      });
      return;
    }
    const main = workLayout(
      mount,
      `<div class="page-head">
         <div>
           <h1>${t('media.title')}</h1>
           <p class="muted" style="margin:0">${t('media.lead')}</p>
         </div>
         <a class="btn btn--ghost btn--small" href="/lehrer" data-link>${t('session.back')}</a>
       </div>
       <div data-library></div>`,
      { teacherName: teacher.displayName },
    );
    library = createMediaLibrary({ mode: 'manage' });
    main.querySelector('[data-library]')?.append(library.element);
  })();

  return () => {
    life.dispose();
    library?.destroy();
  };
}
